import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";

import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";
import { createPayment } from "app/api/payment";

export default function useCreatePayment() {
  const { isLoading, data, mutate, error } = useMutation(createPayment, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;

      toast.error(errorMessage);
    },
  });

  return { isLoading, data: data?.data?.data, createPayment: mutate, error: error ? parseError(error) as string : null };
}
